import { useState } from "react";
import { StyledAnonymousQuestion } from "./index.styled";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { addAnonymousQuestion } from "../../../store/dashboardSlice";
import type { AnonymousQuestion as AnonymousQuestionType } from "../../../types/dashboard";
import { createAnonymousBox, linkBoxToUser } from "../../../utils/apiService";

const AnonymousQuestion = () => {
  const [question, setQuestion] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useAppDispatch();
  const ownerId = useAppSelector((state) => state.dashboard.status?.owner_id);

  const handleSubmit = async () => {
    const trimmedQuestion = question.trim();
    if (!trimmedQuestion || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      const createdBox = await createAnonymousBox({
        title: trimmedQuestion,
        language: "he",
      });

      const newQuestion: AnonymousQuestionType = {
        id: createdBox.id,
        content: createdBox.title,
        public_id: createdBox.public_id,
        short_code: createdBox.short_code,
        admin_id: createdBox.admin_id,
        created_at: createdBox.created_at,
      };

      dispatch(addAnonymousQuestion(newQuestion));
      setQuestion("");

      if (ownerId !== undefined) {
        void linkBoxToUser(createdBox.admin_id, String(ownerId)).catch((error) => {
          console.warn("Failed to link box to user", error);
        });
      }
    } catch (error) {
      console.error("Failed to create anonymous question", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isSubmitDisabled = question.trim().length === 0 || isSubmitting;

  return (
    <StyledAnonymousQuestion>
      <h2 className="title">צרו תיבה וקבלו תגובות</h2>
      <p className="subtitle">
        צרו תיבה ייחודית שלכם וקבלו תגובות אנונימיות מהקהילה
      </p>
      <textarea
        className="question"
        placeholder="כאן רושמים שאלה"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
      />
      <button
        className="submit-button"
        onClick={handleSubmit}
        disabled={isSubmitDisabled}
      >
        {isSubmitting ? "יוצר..." : "יצירת תיבה"}
      </button>
    </StyledAnonymousQuestion>
  );
};

export default AnonymousQuestion;
